export default __webpack_public_path__ + "static/media/bioWel.18f0f209.svg";